var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _circle, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlternativeBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 103,
    viewBox: "0 0 130 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.772 42.2053C141.205 71.6744 118.083 119.127 66.8773 119.983C38.4163 120.457 -0.187846 101.805 0.000687913 58.5587C0.091184 38.7573 25.6337 20.8189 52.9937 44.271C72.9933 61.4132 110.059 15.816 124.772 42.2053Z",
    fill: "#E7EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7871 55.5913L42.8711 58.9281L40.5266 26.5856C37.5607 26.0186 34.333 26.0077 30.8327 26.5856C28.2374 27.5343 27.1797 30.2168 26.9507 37.1084C26.7108 44.0545 27.0597 50.5644 26.7871 55.6022V55.5913Z",
    fill: "#BDC7ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5469 11.8555H54.416V32.9773H37.5469V11.8555Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9879 0.445312L60 15.5261H32.281L45.9879 0.445312Z",
    fill: "#5B86EF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1037 102.654H101.066V34.6434C101.066 31.3721 99.6924 25.5273 89.933 25.5273H65.1146C61.9523 25.6582 61.0582 25.9853 58.9973 26.8141C61.8215 26.5305 64.7875 27.9808 65.1146 33.1604V49.8878V91.4662C65.1146 97.6599 62.2944 102.676 82.1037 102.676V102.654Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8579 102.562H83.5898L72.8 34.5533C72.8 31.2821 71.4276 25.4375 61.6787 25.4375H36.8873C33.7284 25.5683 32.8352 25.8955 30.7765 26.7242C33.5977 26.4407 36.5605 27.8909 36.8873 33.0703V49.7971V91.3743C36.8873 97.5678 39.1965 103.456 53.8579 102.584V102.562Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.7112 64.4883H71.3314C71.7168 64.4883 72.0293 64.8007 72.0293 65.1862V65.3061C72.0293 65.6915 71.7168 66.004 71.3314 66.004H50.7112C50.3258 66.004 50.0133 65.6915 50.0133 65.3061V65.1862C50.0133 64.8007 50.3258 64.4883 50.7112 64.4883Z",
    fill: "#344266"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1429 48.2383H63.7631C64.1485 48.2383 64.4609 48.5507 64.4609 48.9362V49.0561C64.4609 49.4415 64.1485 49.754 63.7631 49.754H43.1429C42.7574 49.754 42.445 49.4415 42.445 49.0561V48.9362C42.445 48.5507 42.7574 48.2383 43.1429 48.2383Z",
    fill: "#E6EBEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2108 44.9915H63.6976C64.112 44.9915 64.4609 44.6534 64.4609 44.2282C64.4609 43.8138 64.1229 43.4648 63.6976 43.4648H54.2108C53.7964 43.4648 53.4475 43.8029 53.4475 44.2282C53.4475 44.6425 53.7855 44.9915 54.2108 44.9915Z",
    fill: "#E6EBEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M81.4912 64.4883H89.724C90.1094 64.4883 90.4219 64.8007 90.4219 65.1862V65.3061C90.4219 65.6915 90.1094 66.004 89.724 66.004H81.4912C81.1058 66.004 80.7933 65.6915 80.7933 65.3061V65.1862C80.7933 64.8007 81.1058 64.4883 81.4912 64.4883Z",
    fill: "#344266"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.7093 72.1992H71.3295C71.7149 72.1992 72.0273 72.5117 72.0273 72.8971V73.017C72.0273 73.4025 71.7149 73.7149 71.3295 73.7149H50.7093C50.3238 73.7149 50.0114 73.4025 50.0114 73.017V72.8971C50.0114 72.5117 50.3238 72.1992 50.7093 72.1992Z",
    fill: "#344266"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M81.4912 72.1992H89.724C90.1094 72.1992 90.4219 72.5117 90.4219 72.8971V73.017C90.4219 73.4025 90.1094 73.7149 89.724 73.7149H81.4912C81.1058 73.7149 80.7933 73.4025 80.7933 73.017V72.8971C80.7933 72.5117 81.1058 72.1992 81.4912 72.1992Z",
    fill: "#344266"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8588 60.9023H95.2012V85.3282H45.8588V60.9023Z",
    stroke: "#C8CFE6",
    strokeWidth: 0.662987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1992 69.0391H45.8568",
    stroke: "#C8CFE6",
    strokeWidth: 0.662987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.7093 80.5312H71.3295C71.7149 80.5312 72.0273 80.8437 72.0273 81.2291V81.3491C72.0273 81.7345 71.7149 82.047 71.3295 82.047H50.7093C50.3238 82.047 50.0114 81.7345 50.0114 81.3491V81.2291C50.0114 80.8437 50.3238 80.5312 50.7093 80.5312Z",
    fill: "#344266"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M81.4912 80.5312H89.724C90.1094 80.5312 90.4219 80.8437 90.4219 81.2291V81.3491C90.4219 81.7345 90.1094 82.047 89.724 82.047H81.4912C81.1058 82.047 80.7933 81.7345 80.7933 81.3491V81.2291C80.7933 80.8437 81.1058 80.5312 81.4912 80.5312Z",
    fill: "#344266"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1992 77.3828H45.8568",
    stroke: "#C8CFE6",
    strokeWidth: 0.662987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8555 60.9023V84.9138",
    stroke: "#C8CFE6",
    strokeWidth: 0.662987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6512 68.7107C32.6512 67.5221 33.6544 66.5625 34.8648 66.5625L60.3483 66.5952C61.5587 66.5952 62.5401 67.5657 62.5292 68.7543L62.2566 103.452C62.2566 104.641 61.2534 105.6 60.043 105.6L34.5594 105.568C33.3491 105.568 32.3677 104.597 32.3786 103.408L32.6512 68.7107Z",
    fill: "#344266"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5888 105.56L62.0724 105.592C63.2828 105.592 64.2751 104.633 64.286 103.444L64.5586 68.7465C64.5586 67.5579 63.5881 66.5874 62.3777 66.5874L36.8942 66.5547C35.6838 66.5547 34.6915 67.5143 34.6806 68.7028L34.4079 103.401C34.4079 104.589 35.3784 105.56 36.5888 105.56Z",
    fill: "#0D318B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7076 79.189L59.7826 79.2108C60.5677 79.2108 61.2111 78.5892 61.2111 77.8259L61.2656 71.316C61.2656 70.5527 60.6441 69.9202 59.859 69.9202L39.784 69.8984C38.9989 69.8984 38.3555 70.52 38.3555 71.2833L38.301 77.7932C38.301 78.5565 38.9225 79.189 39.7076 79.189Z",
    fill: "#F6F8FE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7076 79.189L59.7826 79.2108C60.5677 79.2108 61.2111 78.5892 61.2111 77.8259L61.2656 71.316C61.2656 70.5527 60.6441 69.9202 59.859 69.9202L39.784 69.8984C38.9989 69.8984 38.3555 70.52 38.3555 71.2833L38.301 77.7932C38.301 78.5565 38.9225 79.189 39.7076 79.189Z",
    stroke: "white",
    strokeWidth: 0.766579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2432 87.2376H59.2605C60.1656 87.2376 60.9071 86.507 60.918 85.602C60.918 84.686 60.1874 83.9445 59.2714 83.9336H57.2541C56.349 83.9336 55.6075 84.6642 55.5966 85.5693C55.5966 86.4852 56.3272 87.2267 57.2432 87.2376Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6924 87.2376H50.7097C51.6148 87.2376 52.3563 86.507 52.3672 85.602C52.3672 84.686 51.6366 83.9445 50.7206 83.9336H48.7033C47.7982 83.9336 47.0567 84.6642 47.0458 85.5693C47.0458 86.4852 47.7764 87.2267 48.6924 87.2376Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0674 87.2259H42.0847C42.9898 87.2259 43.7313 86.4953 43.7422 85.5902C43.7422 84.6743 43.0116 83.9328 42.0956 83.9219H40.0783C39.1732 83.9219 38.4318 84.6525 38.4209 85.5575C38.4209 86.4735 39.1514 87.215 40.0674 87.2259Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1866 93.4251H59.2039C60.1089 93.4251 60.8504 92.6945 60.8613 91.7895C60.8613 90.8735 60.1307 90.132 59.2148 90.1211H57.1975C56.2924 90.1211 55.5509 90.8517 55.54 91.7568C55.54 92.6727 56.2706 93.4142 57.1866 93.4251Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6377 93.4095H50.655C51.5601 93.4095 52.3016 92.6789 52.3125 91.7738C52.3125 90.8579 51.5819 90.1164 50.6659 90.1055H48.6486C47.7435 90.1055 47.0021 90.8361 46.9912 91.7411C46.9912 92.6571 47.7217 93.3986 48.6377 93.4095Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0127 93.4017H42.03C42.9351 93.4017 43.6766 92.6711 43.6875 91.766C43.6875 90.8501 42.9569 90.1086 42.0409 90.0977H40.0236C39.1186 90.0977 38.3771 90.8283 38.3662 91.7333C38.3662 92.6493 39.0968 93.3908 40.0127 93.4017Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1436 99.5931H59.1609C60.0659 99.5931 60.8075 98.8625 60.8184 97.9574C60.8184 97.0415 60.0878 96.3 59.1718 96.2891H57.1545C56.2494 96.2891 55.5079 97.0197 55.497 97.9247C55.497 98.8407 56.2276 99.5822 57.1436 99.5931Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5947 99.5853H50.6121C51.5171 99.5853 52.2586 98.8547 52.2695 97.9496C52.2695 97.0337 51.5389 96.2922 50.623 96.2812H48.6057C47.7006 96.2812 46.9591 97.0118 46.9482 97.9169C46.9482 98.8329 47.6788 99.5744 48.5947 99.5853Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9697 99.5736H41.9871C42.8921 99.5736 43.6336 98.843 43.6445 97.9379C43.6445 97.0219 42.9139 96.2804 41.998 96.2695H39.9806C39.0756 96.2695 38.3341 97.0001 38.3232 97.9052C38.3232 98.8212 39.0538 99.5626 39.9697 99.5736Z",
    fill: "#FF8165"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2814 77.6731C59.5977 77.6731 59.8594 77.4223 59.8594 77.1061C59.8594 76.8008 59.6086 76.5391 59.2924 76.5391C58.9761 76.5391 58.7144 76.7899 58.7144 77.1061C58.7144 77.4114 58.9652 77.6731 59.2814 77.6731Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M58.125 102.33L41.4631 102.309",
    stroke: "white",
    strokeWidth: 0.766579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.7953,
    cy: 10.7953,
    r: 10.7953,
    transform: "matrix(-1 0 0 1 94.9688 35.0234)",
    fill: "#00B479"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.7447,
    height: 9.59587,
    rx: 0.872351,
    transform: "matrix(-1 0 0 1 85.0469 41.0273)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.7447,
    height: 9.59587,
    rx: 0.872351,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 79.375 44.9414)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlternativeBg);
export default __webpack_public_path__ + "static/media/AlternativeBG.8d50bace539aaaf71d9aaea89eb0deaa.svg";
export { ForwardRef as ReactComponent };